import { FormControl } from '@angular/forms';

import { isConfigWithControl } from './is-config-with-control';

import { ISPFieldConfig } from '../model';

/**
 * Is field valid and can be submitted
 *
 * @param config - field to check
 */
export function isFieldValid(config: ISPFieldConfig): boolean {
  if (config.props.isHidden) {
    return true;
  }

  // pass fields without form control
  if (!config.formControl || !(config.formControl instanceof FormControl)) {
    return true;
  }

  const hasNoErrors = !Boolean(config.formControl.errors);
  const isMixed =
    isConfigWithControl(config) &&
    config.props.originalControl.$mixed === 'yes';

  return hasNoErrors || isMixed;
}
